import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import useItemBorder from './ItemBorder.hook'

const ItemBorder = props => {
	const [{ classes, children, isActive, isBuilderMode }] = useItemBorder(props)

	if (!isBuilderMode) {
		return children
	}

	return React.Children.map(children, child => {
		return React.cloneElement(child, {
			className: clsx(classes.root, isActive && classes.active, child.props.className),
		})
	})
}

ItemBorder.propTypes = {
	categoryId: PropTypes.number,
	itemKey: PropTypes.string,
	group: PropTypes.string,
	children: PropTypes.node.isRequired,
	outlineOffset: PropTypes.number,
}

ItemBorder.defaultProps = {
	categoryId: null,
	itemKey: null,
	group: null,
	outlineOffset: 0,
}

export default ItemBorder
